import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function WebsiteDevelopment() {
    return (

        <div className="inner-page about contact-page servi-ce-details">

            <Header />


            <div className="rts-breadcrumb-area bg_image">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="baread-crumb-main-wrapper pt--100">
                                <div className="inner">
                                    <h1 className="title rts_hero__title">Website Development</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="service-details-area rts-section-gapTop bg-dark-s">
                <div className="container-150">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="main-page-title-service-left-area">
                                <div className="left">
                                    <h1 className="title-page rts_hero__title">
                                    Web Development Services for<br /> Your Business Goals
                                    </h1>
                                    <div className="bottom-content">
                                        <p className="disc">
                                            Warmonks is renowned as the best web development company in Kerala. With our web development service, we allow businesses to acquire a strong web<br /> presence and thus achieve their online goals. Our team of professional developers and designers at Warmonks works closely with clients to design websites<br /> that are visually appealing, highly functional, and user-friendly. Our years of experience in web development ensure that we tailor each website to every client's<br /> peculiar needs and needs. We've got the very best web designs
                                        </p>
                                        {/* <div className="check-area-main-sd">
                                            <div className="single-check">
                                                <i className="fa-light fa-check"></i>
                                                <p>Content & Software Engineering</p>
                                            </div>
                                            <div className="single-check">
                                                <i className="fa-light fa-check"></i>
                                                <p>Artificial Intelligence and Learning New</p>
                                            </div>
                                            <div className="single-check">
                                                <i className="fa-light fa-check"></i>
                                                <p>Digital Service Platform</p>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="right">
                                    <div className="top-center-image circle-speen rts-scroll-down-circle-wrapper-3">
                                        <a href="#" className="speen-shape scroll-down-circle-3">
                                            <svg className="uni-circle-text-path uk-text-secondary uni-animation-spin"
                                                viewBox="0 0 100 100" width="180" height="180">
                                                <defs>
                                                    <path id="circle"
                                                        d="M 50, 50 m -37, 0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0" />

                                                </defs>
                                                <text font-size="11.75">
                                                    <textPath xlinkHref="#circle">Project SHowcase • Project SHowcase •
                                                    </textPath>
                                                </text>
                                            </svg>
                                            <i className="fa-solid fa-star-sharp"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row pt--80 pt_md--10 pt_sm--0">
                        <div className="col-xl-9 col-lg-12 pr--60 pr_md--15 pr_sm--10 pb_sm--30">

                            <div className="service-details-left">
                                <div className="thumbnaiul-large">
                                    <img src="assets/images/service/04.jpg" alt="service-details" />
                                </div>
                            </div>

                            <div className="single-para-title-service-details mt--40">
                                <h3 className="title">For All Your Website needs</h3>
                                <p className="disc">
                                    A well developed website creates a base for your successful digital strategy. Our dedication towards quality, innovation, and custom-centric design ensures that every web development project represents a strong facilitator in growing your brand and helping your business reach further. We look forward to assisting you in all your new build or redesign/upgrade needs whether it's towards a new venture or to revive an existing presence.
                                </p>
                            </div>


                            {/* <div className="image-thumbnail-2-service-d mt--50">
                                <div className="row g-4">
                                    <div className="col-lg-5">
                                        <div className="thumbnail-service">
                                            <img src="assets/images/service/05.jpg" alt="service" />
                                        </div>
                                    </div>
                                    <div className="col-lg-7">
                                        <div className="thumbnail-service">
                                            <img src="assets/images/service/06.jpg" alt="service" />
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                            <div className="faq-section-start-left-img mt--80">
                                <div className="row">
                                    <div className="col-xl-6 col-lg-12">
                                        <div className="thumbnail">
                                            <img src="assets/images/service/07.png" alt="service_images" />
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-lg-12 pl--50 pl_lg--0">

                                        <div className="service-details-accordion-area">
                                            <h3 className="title">Why choose Warmonks for web development?</h3>
                                            <div className="accordion" id="accordionExample">
                                                <div className="accordion-item">
                                                    <h2 className="accordion-header" id="headingOne">
                                                        <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                                            data-bs-target="#collapseOne" aria-expanded="true"
                                                            aria-controls="collapseOne">
                                                            Custom Solutions
                                                        </button>
                                                    </h2>
                                                    <div id="collapseOne" className="accordion-collapse collapse show"
                                                        aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                                        <div className="accordion-body">
                                                            <p>We build every website with a unique touch according to your business needs so that it depicts the identity of your brand and goals.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="accordion-item">
                                                    <h2 className="accordion-header" id="headingTwo">
                                                        <button className="accordion-button collapsed" type="button"
                                                            data-bs-toggle="collapse" data-bs-target="#collapseTwo"
                                                            aria-expanded="false" aria-controls="collapseTwo">
                                                            Secure and Scalable
                                                        </button>
                                                    </h2>
                                                    <div id="collapseTwo" className="accordion-collapse collapse"
                                                        aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                                        <div className="accordion-body">
                                                            <p>Our web solutions are built with robust security measures and designed to grow your business.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="accordion-item">
                                                    <h2 className="accordion-header" id="headingThree">
                                                        <button className="accordion-button collapsed" type="button"
                                                            data-bs-toggle="collapse" data-bs-target="#collapseThree"
                                                            aria-expanded="false" aria-controls="collapseThree">
                                                            Responsive Design
                                                        </button>
                                                    </h2>
                                                    <div id="collapseThree" className="accordion-collapse collapse"
                                                        aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                                        <div className="accordion-body">
                                                            <p>Our websites are optimized to work perfectly well across any device. whether on desktops or smartphones.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="accordion-item">
                                                    <h2 className="accordion-header" id="headingFour">
                                                        <button className="accordion-button collapsed" type="button"
                                                            data-bs-toggle="collapse" data-bs-target="#collapseFour"
                                                            aria-expanded="false" aria-controls="collapseFour">
                                                            Search engine friendly
                                                        </button>
                                                    </h2>
                                                    <div id="collapseFour" className="accordion-collapse collapse"
                                                        aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                                                        <div className="accordion-body">
                                                            <p>We optimize the speed and search-engine-friendliness of a website so it performs efficiently on a search engine.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-12 mt_lg--50 rts-sticky-column-item">
                            <div className="theiaStickySidebar">
                                <div className="rts-single-wized Categories">
                                    <div className="wized-header">
                                        <h5 className="title">
                                            All Services
                                        </h5>
                                    </div>
                                    <div className="wized-body">

                                        <ul className="single-categories">
                                            <li><a href="/websitedevelopment">Website Development <i className="far fa-long-arrow-right"></i></a></li>
                                        </ul>

                                        <ul className="single-categories">
                                            <li><a href="/appdevelopment">App Development<i className="far fa-long-arrow-right"></i></a>
                                            </li>
                                        </ul>

                                        <ul className="single-categories">
                                            <li><a href="/ecommercedevelopment">Ecommerce Development<i className="far fa-long-arrow-right"></i></a>
                                            </li>
                                        </ul>

                                        <ul className="single-categories">
                                            <li><a href="/digitalmarketing">Digital Marketing<i className="far fa-long-arrow-right"></i></a></li>
                                        </ul>

                                        <ul className="single-categories">
                                            <li><a href="/seo">SEO<i className="far fa-long-arrow-right"></i></a></li>
                                        </ul>

                                        <ul className="single-categories">
                                            <li><a href="/graphicsdesigning">Graphic Designing <i className="far fa-long-arrow-right"></i></a></li>
                                        </ul>

                                    </div>
                                </div>
                                {/* <div className="rts-single-wized Categories">
                                    <div className="wized-header">
                                        <h5 className="title">
                                            Let's start new project.
                                        </h5>
                                    </div>
                                    <div className="wized-body">
                                        <form className="service-details-form" action="#">
                                            <input type="text" placeholder="Your name" />
                                            <input type="text" placeholder="Phone number" />
                                            <textarea placeholder="Message"></textarea>
                                            <button>Start Project</button>
                                        </form>
                                    </div>
                                </div> */}

                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <Footer />

            <div className="loading-screen" id="loading-screen">
                <span className="bar top-bar"></span>
                <span className="bar down-bar"></span>
                <span className="progress-line"></span>
                <span className="loading-counter"> </span>
            </div>


            <div className="bg-noise"></div>



            <div className="progress-wrap">
                <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
                    <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"></path>
                </svg>
            </div>

            <div className="rts-cursor cursor-outer" data-default="yes" data-link="yes" data-slider="no">
                <span className="fn-cursor"></span>
            </div>
            <div className="rts-cursor cursor-inner" data-default="yes" data-link="yes" data-slider="no">
                <span className="fn-cursor">
                    <span className="fn-left"></span>
                    <span className="fn-right"></span>
                </span>
            </div>

            <div className="modal-sidebar-scroll rts-dark-light">
                <ul>
                    <li className="go-dark-w"><span>Dark</span><i className="rts-go-dark fal fa-moon"></i></li>
                    <li className="go-light-w"><span>Light</span><i className="rts-go-light fa-light fa-brightness"></i></li>
                </ul>
            </div>


        </div>
    )
}

export default WebsiteDevelopment
